import { useState, useEffect } from 'react';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiEdit, FiSave, FiX, FiRefreshCw } from 'react-icons/fi';

const LeaveBalanceList = () => {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({ sick: 0, casual: 0, annual: 0 });
  const [year, setYear] = useState(new Date().getFullYear());

  const fetchBalances = async () => {
    try {
      setLoading(true);
      const res = await api.get('/leaves/balance', { params: { year } });
      setBalances(res.data);
    } catch (err) {
      toast.error('Failed to fetch leave balances');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchBalances(); }, [year]);

  const handleEdit = (b) => {
    setEditId(b.employee._id);
    setEditForm({ sick: b.sick, casual: b.casual, annual: b.annual });
  };

  const handleCancel = () => {
    setEditId(null);
  };

  const handleSave = async (employeeId) => {
    try {
      await api.put(`/leaves/balance/${employeeId}`, { ...editForm, year });
      toast.success('Leave balance updated');
      setEditId(null);
      fetchBalances();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Update failed');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <h1>Leave Balances</h1>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <select value={year} onChange={e => setYear(Number(e.target.value))}>
            {[year - 1, year, year + 1].map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          <button className="btn-secondary" onClick={fetchBalances} title="Refresh"><FiRefreshCw /></button>
        </div>
      </div>

      <table className="table" style={{ marginTop: '1rem' }}>
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Employee</th>
            <th>ID</th>
            <th>Department</th>
            <th>Sick</th>
            <th>Casual</th>
            <th>Annual</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {balances.map((b, index) => (
            <tr key={b.employee._id}>
              <td>{index + 1}</td>
              <td><strong>{b.employee.name}</strong></td>
              <td>{b.employee.employeeId}</td>
              <td>{b.employee.department?.name || '-'}</td>
              {editId === b.employee._id ? (
                <>
                  <td><input type="number" value={editForm.sick} onChange={e => setEditForm({ ...editForm, sick: Number(e.target.value) })} style={{ width: '70px' }} /></td>
                  <td><input type="number" value={editForm.casual} onChange={e => setEditForm({ ...editForm, casual: Number(e.target.value) })} style={{ width: '70px' }} /></td>
                  <td><input type="number" value={editForm.annual} onChange={e => setEditForm({ ...editForm, annual: Number(e.target.value) })} style={{ width: '70px' }} /></td>
                  <td className="actions">
                    <button className="btn-sm btn-success" onClick={() => handleSave(b.employee._id)}><FiSave /> Save</button>
                    <button className="btn-sm btn-danger" onClick={handleCancel}><FiX /> Cancel</button>
                  </td>
                </>
              ) : (
                <>
                  <td>{b.sick}</td>
                  <td>{b.casual}</td>
                  <td>{b.annual}</td>
                  <td className="actions">
                    <button className="btn-sm btn-warning" onClick={() => handleEdit(b)}><FiEdit /> Edit</button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {balances.length === 0 && (
            <tr><td colSpan="8" style={{ textAlign: 'center' }}>No balances found</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LeaveBalanceList;
